const ToolbarContainer = ( props ) => (
	<div className={ props.className }>
		{ props.children }
	</div>
);
export default ToolbarContainer;
